<template>
  <v-btn
    @click="$emit('onClick')"
    color="primary"
    style="top: 16px;"
    absolute
    dark
    fab
    top
    right
  >
    <v-icon v-text="icon" style="padding: 16px" />
  </v-btn>
</template>

<script>
export default {
  name: 'CampaignModalPageCreativeButtonAdd',
  props: {
    icon: {
      type: String,
      default: 'add',
    },
  },
}
</script>
